module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-07.3df911e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-07.jpg
// module id = /Kzk
// module chunks = 51